import { Link } from "react-router-dom";
import karjooImage from "../../image/karjoo.jpg";
export default function PrivacyPolicy() {
  return (
    <div className="flex flex-col justify-center items-center">
      <div className="flex flex-col justify-center sm:mx-[4%] my-[1%] mx-[1%] md:mx-[20%]">
        <div className="flex flex-col">
          <h1 className="text-2xl font-bold  my-[3.5%]">
            شرایط و قوانین ATS کارجو پلاس
          </h1>
          <div className="bg-white shadow-md rounded-sm p-[2%] border-[1px] border-slate-200 ">
            <h1 className="text-l font-semibold">ماده۱: تعاریف و اصطلاحات</h1>
            <div className="flex flex-col gap-y-5 p-[1%] text-xs my-[2%]">
              <p>
                ۱-۱ شرکت: شرکت همکار پشتکار کوشا که نسبت به ارائه سرویس ATS
                کارجو پلاس اقدام می‌کند.
              </p>
              <p>
                ۱-۲ ATS کارجو پلاس(سیستم مدیریت فرایند استخدام): خدمات نرم
                افزاری جذب و استخدام نیروی انسانی که توسط شرکت به منظور تسهیل
                فرایند استخدام و سهولت در یافتن مناسب ترین متقاضیان برای
                کارفرمایان ارائه می‌شود.
              </p>
              <p>
                ۱-۳ کارفرما: هر شرکت، فرد یا مجموعه (اعم از اشخاص حقیقی و
                حقوقی)ای که در ATS کارجو پلاس به عنوان کارفرما ثبت نام کرده است.
                کارفرما قصد استفاده از این سرویس برای جذب نیرو به وسیله خدمات
                آن، و تسهیل در فرایند استخدام کارمندان خود دارد.
              </p>
              <p>
                ۱-۴ اطلاعات کارجویان: آن دسته از اطلاعاتی از کارجویان که از
                جانب کارفرما در نرم افزار ثبت شده و همچنین آن دسته از اطلاعاتی
                که کارجویان خود در سیستم ثبت کرده اند.
              </p>
              <p>
                ۱-۵ اطلاعات کارفرما: آن دسته از اطلاعاتی که کارفرما در خصوص خود
                و کار خود در سیستم ثبت کرده است.
              </p>
            </div>
            <h1 className="text-l font-semibold">ماده۲: قوانین عمومی</h1>
            <div className="flex flex-col gap-y-5 p-[1%] text-xs my-[2%]">
              <p>
                ۲-۱ کلیه ی اصول و رویه های ATS کارجو پلاس منطبق با قوانین جهموری
                اسلامی ایران است و متعاقباً کاربران نیز موظف به رعایت قوانین
                مرتبط می‌باشند.
              </p>
              <p>
                ۲-۲ استفاده از خدمات ATS کارجو پلاس به معنای آگاهی، پذیرش و
                التزام به شرایط و تعهدات مندرج در این شرایط و قوانین از سوی
                کاربران می‌باشد.
              </p>
              <p>
                ۲-۳ شرکت حق اصلاح و تغییر این شرایط و قوانین را کلا و جزئا
                داراست و می‌بایست شرایط و قوانین اصلاح شده یا تغییریافته را از
                طریق وبگاه و اعلان وب اپلیکیشن به اطلاع کاربران برساند. تغییرات
                ایجاد شده فورا اعمال می‌گردند. استفاده کاربران از خدمات بعد از
                تاریخ اعلام تغییرات به معنی پذیرش تمامی تغییرات مذکور است.
              </p>

              <p>
                ۲-۴ در صورت گزارش مزاحمت برای کاربران و بررسی صحت گزارش با توجه
                به سیستم ترکینگ موجود، شرکت اختیار ارائه اطلاعات فرد مزاحم را
                برای پیگیری موارد قانونی به مراجع ذی صلاح دارد.
              </p>
            </div>
            <h1 className="text-l font-semibold">
              ماده۳: شرایط بهره مندی کارفرمایان از خدمات ATS کارجو پلاس
            </h1>
            <div className="flex flex-col gap-y-5 p-[1%] text-xs my-[2%]">
              <p>
                ۳-۱ کارفرما متعهد می‌شود که اطلاعات کارجویانی که در اختیار دارد
                به صورت محرمانه نزد خود نگهدارد و از انتشار، خرید، فروش و انتقال
                این اطلاعات خودداری کند. چنانچه کارفرما اقدام به موارد مذکور
                نماید، شرکت می‌تواند علاوه بر قطع خدمات، موارد را از طریق مقامات
                ذی صلاح پیگیری نماید.
              </p>
              <p>
                ۳-۲ کارفرما متعهد می‌شود اطلاعات خود را در کمال صحت در سیستم ثبت
                کند. چناچه خلاف آن ثابت شود، شرکت می‌تواند از ارائه خدمات به
                کارفرمای مذکور امتناع ورزد.
              </p>
              <p>
                ۳-۳ قطع ارائه خدمات برای کارفرمایان بدون عودت وجه پرداخت شده
                می‌باشد. اگر شرکت چه به صورت قراردادی چه به صورت قهری و به هر
                طریق دیگر از ارائه خدمات به کارفرما امتناع کند، وجه پرداختی به
                هیچ عنوان به کارفرما عودت داده نخواهد شد.
              </p>
              <p>
                ۳-۴ چنانچه کارفرما حساب کاربری خود را شارژ نکند، خدمات ساخت
                رویداد جدید، به روز رسانی کاندید، مدیریت کاندیدها و بروزرسانی
                شغل برای وی قطع خواهد شد و فقط اطلاعات قبلی قابل دسترس خواهد
                بود. در صورتی که کارفرما از شارژ حساب کاربری خود امتناع کند، طی
                مدت ۱۰ روز تمامی اطلاعات، آگهی ها و... وی حذف خواهد شد و
                کارفرما حق هیچ گونه اعتراضی در قبال حذف موارد مذکور نخواهد داشت.
              </p>
              <p>
                ۳-۵ کارفرما با ثبت نام در سرویس متعهد می‌شود از خدمات سرویس فقط
                در جهت استخدام در شرکت/کار خودش استفاده کند و نمی‌تواند از حساب
                کاربری خود برای دیگر کارفرمایان استفاده نماید. در صورت مشاهده
                مورد فوق شرکت می‌تواند از ارائه خدمات به کارفرمای مذکور امتناع
                ورزد و موارد را از طریق مقامات ذی صلاح پیگیری نماید.
              </p>
            </div>
            <h1 className="text-l font-semibold">
              ماده۴: مسئولیت ATS کارجو پلاس
            </h1>
            <div className="flex flex-col gap-y-5 p-[1%] text-xs my-[2%]">
              <p>
                ۴-۱ شرکت با استفاده از ظرفیت های خود تلاش می‌کند خدمات با کیفیت
                مطلوب به کاربران ارائه دهد.
              </p>
              <p>
                ۴-۲ شرکت در جهت فراهم کردن امکان استفاده از خدمات نرم افزاری
                توسط دستگاه های کاربران تلاش می‌کند اما تضمینی نسبت به اجرا شدن
                آن روی همه ی دستگاه ها یا شبکه های ارتباطی (اینترنت، شبکه تلفن
                همراه و...) نخواهد داد.
              </p>
              <p>
                ۴-۳ اطلاعات کارفرمایان نزد شرکت محافظت شده و دسترسی به آن توسط
                اشخاص ثالث ممنوع بوده مگر در برابر قانون و تصمیم مقام ذی صلاح
                قضایی.
              </p>
              <p>
                ۴-۴ چنانچه هر یک از کاربران ATS کارجو پلاس در زمان استفاده از
                خدمات آن با مشکل مواجه شوند می‌توانند از طریق ارسال پیام از
                قسمت چت آنلاین در سیستم موضوع را مطرح کنند. شرکت پیگیری لازم را
                بنا به مورد انجام خواهد داد و در جهت حل مشکل تلاش به عمل خواهد
                آورد.
              </p>
              <p>
                ۴-۵ شرکت از طریق این سرویس خدماتی چون ایجاد و مدیریت موقعیت
                شغلی، اضافه کردن و مدیریت کاندیدها به صورت تکی و گروهی، خواندن
                رزومه ها به فرمت Word ،PDF و Excel، ایجاد، ارسال و مدیریت فرم ها
                و پرسش نامه ها، تعریف و مدیریت وظایف به منظور انجام کارها در
                سازمان، تطبیق هر رزومه با موقعیت شغلی، مدیریت قرارها و جلسات در
                تقویم کاری، ذخیره رزومه ها در مخزن استعدادها، ساخت صفحه موقعیت
                های شغلی برای دریافت رزومه ها در اعزای حق اشتراک ارائه می‌کند.
              </p>
              <p>
                ۴-۶ حق اشتراک به صورت ماهانه، سه ماهه و شش ماهه قابل پرداخت
                می‌باشد. شرکت می‌تواند مبلغ حق اشتراک را افزایش داده و می بایست
                تغییرات در مبالغ را در صفحه ی پرداخت به کاربران اعلام کند.
              </p>
              <p>
                ۴-۷ شرکت مسئولیتی در قبال ایفای تعهدات کارجو و کارفرما در مقابل
                یکدیگر ندارد.
              </p>
              <p>
                ۴-۸ شرکت مسئولیتی در خصوص تضمین حضور کارجو و کارفرما در زمان و
                مکان تعیین شده برای مصاحبه حضوری ندارد.
              </p>
              <p>
                ۴-۹ مسئولیت حفاظت از اطلاعات کارجویانی که توسط کارفرما در ATS
                کارجو پلاس ثبت می‌شود با خود کارفرما بوده و شرکت هیچ گونه
                مسئولیتی در قبال اطلاعات از قبیل صحت، رضایت کارجو در ثبت
                اطلاعات و... ندارد.
              </p>
              <p>
                ۴-۱۰ اطلاعات کارجویانی که توسط خود کارجو در سیستم ثبت شده است به
                عهده خود کارجو بوده و شرکت مسئولیتی در این موارد ندارد.
              </p>
              <p>
                ۴-۱۱ شرکت هیچ گونه مسئولیتی در مقابل صحت اطلاعات ثبت شده از سوی
                کاربران(اعم از کارجو و کارفرما) ندارد و فقط در صورت احراز عدم
                صحت اطلاعات می‌تواند از ارائه خدمات به کاربر خاطی امتناع ورزد.
              </p>
              <p>
                ۴-۱۲ شرکت صرفاً مسئول ارائه خدمات مذکور در بند۵ ماده۴ می‌باشد
                و هیچ گونه مسئولیتی در قبال استخدام یا عدم استخدام، ایفای
                تعهدات طرفین، حضور یا عدم حضور در مصاحبه های مقرر و... که مربوط
                به روابط کارجو و کارفرما نسبت به یکدیگر می‌باشد، ندارد.
              </p>
            </div>
            <h1 className="text-l font-semibold">
              ماده۵: شرایط قطع ارائه خدمات ATS کارجو پلاس
            </h1>
            <div className="flex flex-col gap-y-5 p-[1%] text-xs my-[2%]">
              <p>
                ۵-۱ چنانچه کاربر اطلاعات غیرواقعی در حساب کاربری خورد قرار دهد
                در صورت احراز شرکت می‌تواند از ارائه خدمات به آن کاربر ممانعت
                کرده و حساب کاربری شخص را مسدود کند.
              </p>
              <p>
                ۵-۲ چنانچه کارفرما اطلاعات سایر کارجویان را تحصیل کرده و در
                اختیار اشخاص ثالث قرار دهد(از جمله فروش اطلاعات کاربران و...)
                شرکت می‌تواند از ارائه خدمات به آن کارفرما ممانعت کرده و حساب
                کاربری شخص را مسدود کند. علاوه بر آن شرکت می‌تواند موارد مذکور
                را از طریق مقامات ذی صلاح قانونی و قضائی پیگیری کند.
              </p>
              <p>
                ۵-۳ چناچه کارفرما از اطلاعات تماس کارجویان سوءاستفاده کرده و
                برای کارجو یا کارجویانی ایجاد مزاحمت نماید، شرکت می‌تواند از
                ارائه خدمات به آن کارفرما ممانعت کرده و حساب کاربری شخص را
                مسدود کند و علاوه بر آن شرکت می‌تواند موارد مذکور را از طریق
                مقامات ذی صلاح قانونی و قضائی پیگیری کند.
              </p>
              <p>
                ۵-۴ قرار دادن محتوای مجرمانه و خلاف قوانین و مقررات جمهوری
                اسلامی ایران در حساب کاربری کاربران ممنوع بوده و چنانچه کاربری
                چنین محتوایی در حساب کاربری خود قرار دهد، شرکت می‌تواند از
                ارائه خدمات به آن کاربر ممانعت کرده و حساب کاربری شخص را مسدود
                کند. همچنین مسئولیت کلیه ی اقدامات و افعال کاربران که ناشی از
                عدم رعایت قوانین جمهوری اسلامی ایران باشد، بر عهده ی شخص متخلف
                بوده و شرکت هیچ گونه مسئولیتی در قبال اعمال و افعال مذکور
                ندارد. شرکت می‌تواند از ارائه خدمات به آن کاربر ممانعت کرده و
                حساب کاربری شخص را مسدود کند.
              </p>
              <p>
                ۵-۵ هرگونه اقدامی از سوی کاربر که منجر به ورود خسارت به شهرت،
                اعتبار و دارایی های شرکت شود تخلف از شرایط قراردادی و قانونی
                تلقی می‌شود، شرکت می‌تواند در مواجهه با چنین مواردی حساب کاربری
                شخص را مسدود کرده و علاوه بر آن میتواند اقدامات قانونی لازم را
                علیه متخلف به عمل آورد و خسارت و حقوق قانونی خود را مطالبه کند.
              </p>
              <p>
                ۵-۶ کپی از نرم افزار ATS کارجو پلاس ممنوع و در حکم غصب میباشد.
                در صورت مشاهده چنین مواردی شرکت پیگیری لازم را در جهت مطالبه
                خسارت و حقوق قانونی خود نزد مقامات ذی صلاح به عمل خواهد آورد.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center w-[26%] h-[26%] my-[8%] sm:my-[4%] sm:w-[10%] sm:h-[10%] ">
        <Link target="__blank" to={"https://karjoo.plus"}>
          <img src={karjooImage} alt="" />
        </Link>
      </div>
    </div>
  );
}
